import jquery from 'jquery'

(function ($) {
  $(document).on('turbolinks:load', function () {
    var body = $('body')
    var vbcContent = $('.vbc')
    var vbcMainHead = $('.vbc__main__head')
    var vbcTopbarHeight = $('.vbc-topbar').outerHeight(true)
    var vbcBottombarHeight = $('.vbc-bottombar').outerHeight(true)
    var vbcLeftDrawer = $('.vbc-left-drawer')
    var vbcOpenLeftDrawer = $('.js-open-left-drawer-button')
    var vbcCloseLeftDrawer = $('.js-close-left-drawer-button')
    var vbcRightDrawer = $('.vbc-right-drawer')
    var vbcOpenRightDrawer = $('.js-open-right-drawer-button')
    var vbcCloseRightDrawer = $('.js-close-right-drawer-button')
    var vbcMainMenu = $('.vbc-main-menu')
    var vbcOpenMainMenu = $('.js-open-main-menu-button')
    var vbcCloseMainMenu = $('.js-close-main-menu-button')
    var vbcBottomDrawer = $('.vbc-bottom-drawer')
    var vbcOpenBottomDrawer = $('.js-open-bottom-drawer-button')
    var vbcCloseBottomDrawer = $('.js-close-bottom-drawer-button')
    var vbcNewPostDrawer = $('.vbc-new-post-drawer')
    var vbcOpenNewPostDrawer = $('.js-open-new-post-drawer-button')
    var vbcCloseNewPostDrawer = $('.js-close-new-post-drawer-button')
    var vbcFeedbackDrawer = $('.vbc-feedback-drawer')
    var vbcOpenFeedbackDrawer = $('.js-open-feedback-drawer-button')
    var vbcCloseFeedbackDrawer = $('.js-close-feedback-drawer-button')
    var vbcMessenger = $('.vbc-messenger')
    var vbcOpenMessenger = $('.js-open-messenger-button')
    var vbcCloseMessenger = $('.js-close-messenger-button')
    var vbcQRCode = $('.vbc-qrcode')
    var vbcOpenQRCode = $('.js-open-qrcode-button')
    var vbcCloseQRCode = $('.js-close-qrcode-button')
    var vbcIntrosItem = $('.vbc-intros__list__item')
    var vbcToggleDropdown = $('.js-toggle-dropdown')

    /*
      layout calculations
     */
    vbcContent.css({
      'padding-top': vbcTopbarHeight,
      'padding-bottom': vbcBottombarHeight
    })

    vbcMainHead.css({
      'padding-top': vbcTopbarHeight
    })

    /*
     left drawer triggers
     */
    vbcOpenLeftDrawer.on('click', function () {
      vbcLeftDrawer.addClass('vbc-left-drawer--active')
      body.addClass('u-no-scroll-y')
    })

    vbcCloseLeftDrawer.on('click', function () {
      vbcLeftDrawer.removeClass('vbc-left-drawer--active')
      body.removeClass('u-no-scroll-y')
    })

    /*
     right drawer triggers
     */
    vbcOpenRightDrawer.on('click', function () {
      vbcRightDrawer.addClass('vbc-right-drawer--active')
      body.addClass('u-no-scroll-y')
    })

    vbcCloseRightDrawer.on('click', function () {
      vbcRightDrawer.removeClass('vbc-right-drawer--active')
      body.removeClass('u-no-scroll-y')
    })

    /*
     vbc main menu triggers
     */
    vbcOpenMainMenu.on('click', function () {
      vbcMainMenu.addClass('vbc-main-menu--active')
      body.addClass('u-no-scroll-y')
    })

    vbcCloseMainMenu.on('click', function () {
      vbcMainMenu.removeClass('vbc-main-menu--active')
      body.removeClass('u-no-scroll-y')
    })

    /*
     bottom drawer triggers
     */
    vbcOpenBottomDrawer.on('click', function (e) {
      e.preventDefault()
      vbcBottomDrawer.addClass('vbc-bottom-drawer--active')
      body.addClass('u-no-scroll-y')
    })

    vbcCloseBottomDrawer.on('click', function () {
      vbcBottomDrawer.removeClass('vbc-bottom-drawer--active')
      body.removeClass('u-no-scroll-y')
    })

    /*
     new post drawer triggers
     */
    vbcOpenNewPostDrawer.on('click', function (e) {
      e.preventDefault()
      vbcNewPostDrawer.addClass('vbc-new-post-drawer--active')
      body.addClass('u-no-scroll-y')
    })

    vbcCloseNewPostDrawer.on('click', function () {
      vbcNewPostDrawer.removeClass('vbc-new-post-drawer--active')
      body.removeClass('u-no-scroll-y')
    })

    /*
     feedback drawer triggers
     */
    vbcOpenFeedbackDrawer.on('click', function (e) {
      e.preventDefault()
      e.stopPropagation()
      vbcFeedbackDrawer.addClass('vbc-feedback-drawer--active')
      body.addClass('u-no-scroll-y')
    })

    vbcCloseFeedbackDrawer.on('click', function () {
      vbcFeedbackDrawer.removeClass('vbc-feedback-drawer--active')
      body.removeClass('u-no-scroll-y')
    })

    /*
     messenger
     */
    vbcOpenMessenger.on('click', function (e) {
      e.preventDefault()
      vbcMessenger.addClass('vbc-messenger--active')
      body.addClass('u-no-scroll-y')
    })

    vbcCloseMessenger.on('click', function () {
      vbcMessenger.removeClass('vbc-messenger--active')
      body.removeClass('u-no-scroll-y')
    })

    /*
     qrcode modal triggers
     */
    vbcOpenQRCode.on('click', function (e) {
      e.preventDefault()
      vbcQRCode.addClass('vbc-qrcode--active')
      body.addClass('u-no-scroll-y')
    })

    vbcCloseQRCode.on('click', function () {
      vbcQRCode.removeClass('vbc-qrcode--active')
      body.removeClass('u-no-scroll-y')
    })

    /*
     show intro list item button
     */
    vbcIntrosItem.on('click', function (e) {
      e.preventDefault()
      $(this).toggleClass('vbc-intros__list__item--active')
    })

    /*
     toggle dropdown
     */
    vbcToggleDropdown.on('click', function (e) {
      e.preventDefault()
      $(this).parents('.dropdown').toggleClass('dropdown--active')
    })
  })
})(jquery)
